import React from "react";
import { Box, Button, useMediaQuery } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import CardCourse from "../../../../shared/CardCourse";
import "./Catalog.scss";
import { useNavigate } from "react-router-dom";

const Catalog = ({ card, title, total, setPage, page, isHome }: any) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:1000px)");
  const limit = isMobile ? 1 : 4;

  return (
    <Box className={"catalog-wrapper"}>
      <Box className={"catalog-title"}>
        {title}
        <Box>
          <ArrowBackIosNewIcon
            onClick={() => {
              if (page - 1 < 0) {
                setPage(total - limit);
              } else {
                setPage(page - 1);
              }
            }}
            className={"catalog-arrow"}
            sx={{ marginRight: "12px" }}
          />
          <ArrowForwardIosIcon
            className={"catalog-arrow"}
            onClick={() => {
              if (total - (page + 1) < limit) {
                setPage(0);
              } else {
                setPage(page + 1);
              }
            }}
          />
        </Box>
      </Box>
      <Box className={"catalog-items"}>
        {card.map((el: any) => (
          <CardCourse info={el} key={el.id} isHome />
        ))}
      </Box>
      <Button
        variant="outlined"
        className={"catalog-btn"}
        onClick={() => navigate("/search")}>
        Посмотреть все
      </Button>
    </Box>
  );
};

export default Catalog;
